/** 208300 -> "03:28.300" */
export function fmtMs(ms: number): string {
  const total = Math.max(0, Math.round(ms));
  const m = Math.floor(total / 60_000);
  const s = Math.floor((total % 60_000) / 1000);
  const frac = total % 1000;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}.${String(frac).padStart(3, '0')}`;
}

export function fmtSeconds(seconds: number): string {
  return fmtMs(seconds * 1000);
}
